import { api } from "../services/Api";
import { filterAndPageableToRequest } from "../utils/filterAndPageableToRequest";

interface CreateInvoiceData {
    sellerDocument: string;
    date: string;
    amount: number;
    email: string;
    observation: string;
}

export function useInvoice() {
  const baseUrl = "/barte/invoices";

  const getInvoices = async (filter: object, pageable: object) => {
    return await api.get(`${baseUrl}${filterAndPageableToRequest({ filter, pageable })}`);
  }

  const postInvoice = async (invoiceData: CreateInvoiceData) => {
    return await api.post(`${baseUrl}`, invoiceData);
  }

  const cancelInvoice = async (uuidInvoice: string) => {
    return await api.delete(`${baseUrl}/${uuidInvoice}`);
  }

  const sendInvoiceEmail = async(uuidInvoice: string) => {
    return await api.patch(`${baseUrl}/${uuidInvoice}/email`);
  }

  const postImportInvoice = (file: File) => {
    let formData = new FormData();
    formData.append("file", file);
    return api.post(`${baseUrl}/import`, formData);
  }

  return {
    getInvoices,
    postInvoice,
    postImportInvoice,
    sendInvoiceEmail,
    cancelInvoice,
  }
}
